module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/MATTRZ_CX_ZERO_full_w-185e4d8fbe92687d00a6453173e7722e.svg";